module.exports = __webpack_public_path__ + "img/Icon-Res-Example.6155b17e.svg";